import { Input, Component } from '@angular/core';

@Component({
  selector: 'app-empty-list',
  templateUrl: './empty-list.component.html',
  styleUrls: ['./empty-list.component.scss'],
  standalone: false,
})
export class EmptyListComponent {
  @Input() title?: string;
  @Input() info?: string;
  @Input() icon? = 'inbox';
  @Input() color?: 'primary' | 'secondary' = 'primary';
}
